import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ProductGroupsList from "components/layout/ProductGroups/ProductGroupsList";
import {withRouter} from "react-router-dom";


class ProductGroups extends React.Component {

  render() {

    const {
      intl: { messages },
    } = this.props;


    return (
      <>
        <ProductGroupsList />
      </>
    );
  }
}
ProductGroups.defaultProps = {

};

const mapStateToProps = state => {
  return {
    user: state.login.user,
  };
};

export default injectIntl(
  withRouter(
    connect(
      mapStateToProps,

    )(ProductGroups)
  )
);
